/* Surfin Balance – kleine Helfer zur Design-Ebene (assets/sb-design.css).
   Sprungmarken: Ein Link "#kaufen" springt zum Abschnitt, dessen Abschnitts-ID im Editor/JSON "kaufen" lautet
   (Shopify vergibt dafür die ID "shopify-section-template--…__kaufen"). */
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href^="#"]');
  if (!link) return;
  const key = link.getAttribute('href').slice(1);
  if (!key || document.getElementById(key)) return;
  const target = document.querySelector(`[id^="shopify-section-"][id$="__${CSS.escape(key)}"]`);
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  history.replaceState(null, '', `#${key}`);
});

/* Trusted-Shops-Bewertungszeile (snippets/sb-ts-rating.liquid): füllt {rating}/{count} aus dem öffentlichen
   eTrusted-Feed, je Kanal einmal je Sitzung abgerufen. Ohne Daten bleibt die ganze Bewertungszeile ausgeblendet. */
(() => {
  const els = document.querySelectorAll('[data-sb-ts-rating]');
  if (!els.length) return;
  const load = (channel) => {
    const key = `sb-ts-grades-${channel}`;
    try {
      const cached = JSON.parse(sessionStorage.getItem(key));
      if (cached) return Promise.resolve(cached);
    } catch (e) {}
    return fetch(`https://integrations.etrusted.com/feeds/grades/v1/channels/${channel}/touchpoints/all/feed.json`)
      .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
      .then((data) => {
        try { sessionStorage.setItem(key, JSON.stringify(data.grades)); } catch (e) {}
        return data.grades;
      });
  };
  const fmt = (n, digits) => n.toLocaleString('de-DE', { minimumFractionDigits: digits, maximumFractionDigits: digits });
  els.forEach((el) => {
    load(el.dataset.channel)
      .then((grades) => {
        const grade = grades[el.dataset.period] || grades.overall;
        if (!grade || !grade.count) throw new Error('keine Bewertungen');
        el.textContent = el.dataset.format.replace('{rating}', fmt(grade.rating, 2)).replace('{count}', fmt(grade.count, 0));
        el.style.visibility = '';
      })
      .catch(() => {
        (el.closest('[class*="__rating"]') || el).hidden = true;
      });
  });
})();

/* Versandkosten schätzen (snippets/shipping-estimator.liquid): Essence zeigt "Name: 10.00 EUR".
   SB: Preis als Währung im Shop-Format, 0 = "kostenlos", Lieferzeit falls in Shopify hinterlegt. */
customElements.whenDefined('shipping-estimator').then(() => {
  const Estimator = customElements.get('shipping-estimator');
  const original = Estimator.prototype.displayShippingRates;
  Estimator.prototype.displayShippingRates = function (rates) {
    if (!rates || rates.length === 0) return original.call(this, rates);
    const locale = document.documentElement.lang || 'de';
    this.shippingRates.textContent = '';
    rates.forEach((rate) => {
      const amount = parseFloat(rate.price);
      const price = amount === 0 ? 'kostenlos' : new Intl.NumberFormat(locale, { style: 'currency', currency: rate.currency }).format(amount);
      const li = document.createElement('li');
      li.textContent = `${rate.name}: ${price}`;
      if (rate.delivery_range && rate.delivery_range.length === 2) {
        const [from, to] = rate.delivery_range.map((d) => new Date(d).toLocaleDateString(locale, { day: 'numeric', month: 'numeric' }));
        li.textContent += ` (Lieferung ${from === to ? `am ${from}` : `${from}–${to}`})`;
      }
      this.shippingRates.appendChild(li);
    });
  };
});

/* Linien-Umschalter (snippets/sb-line-switch.liquid): merkt sich beim Klick, wo der Umschalter im Bildschirm
   steht. Die Zielseite setzt ihren Umschalter an dieselbe Stelle – der Wechsel wirkt wie eine Farbwahl. */
document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-sb-line-link]');
  if (!link) return;
  const anchor = document.getElementById('sb-line-switch');
  if (!anchor) return;
  try {
    /* Kompakte Auswahl: Die Reihenfolge der Linien bleibt beim Wechsel stehen – die zuerst geöffnete Seite gibt sie vor */
    const wrapper = anchor.closest('.product-variant-picker');
    const swap = anchor.classList.contains('sb-compact') && !(wrapper && wrapper.classList.contains('sb-compact--swap'));
    sessionStorage.setItem('sb-line-switch', JSON.stringify({ top: anchor.getBoundingClientRect().top, swap, t: Date.now() }));
  } catch (e) {}
});
